import size from 'lodash/size'
import isEmpty from 'lodash/isEmpty'
import type { FunctionComponent } from 'react'
import React from 'react'
import { Tag } from './Tag'
import { useShowMore } from '@ztechapps/common.hook'
import { ShowIf } from '@ztechapps/webui.util'
import { Badge } from 'react-bootstrap'

export type TagsProps<T> = {
  dataArray?: T[]
  children?: React.ReactNode
  tagComponent?: FunctionComponent<{ value: T }>
  className?: string
  maxVisible?: number
}

export function Tags<T>({ dataArray, children, tagComponent, className, maxVisible }: TagsProps<T>) {
  const { newItems, isOpenMore, setIsOpenMore } = useShowMore({
    items: dataArray,
    limit: maxVisible ?? size(dataArray),
  })

  if (!dataArray) return null

  const Component = tagComponent || (Tag as FunctionComponent<{ value: T }>)
  const defaultClassName = 'justify-content-start'
  const remainingCount = size(dataArray) - (maxVisible ?? 0)

  return (
    <div className={`d-flex flex-wrap gap-1 ${className || defaultClassName}`}>
      {newItems.map((m, i) => (
        <div key={`Tag${i}`}>
          <Component value={m} />
        </div>
      ))}
      <ShowIf condition={!isEmpty(dataArray) && maxVisible !== undefined && size(dataArray) > maxVisible}>
        <Badge bg={'secondary'} onClick={setIsOpenMore}>
          {isOpenMore ? 'Show less' : `Show ${remainingCount} more`}
        </Badge>
      </ShowIf>
      {children}
    </div>
  )
}
